export default "__VITE_ASSET__CLo32zoJ__"